import { JobType, Team } from './types';

const teamJobLookup = {
  [Team.DOCUMENT_SORTING]: [JobType.TRIAGE_CLIENT_DOCUMENTS],
  [Team.CATEGORIZATION]: [
    JobType.CATEGORIZE_CLIENT_TRANSACTIONS,
    JobType.REVIEW_GENERAL_LEDGER,
    JobType.RESOLVE_INCORRECT_CATEGORIZATION,
  ],
  [Team.ADJUSTMENTS]: [
    JobType.RESOLVE_3RD_PARTY_LOGIN_ADJUSTMENT,
    JobType.RESOLVE_DOCUMENT_ADJUSTMENT,
    JobType.RESOLVE_BULK_ADJUSTMENT,
    JobType.RESOLVE_INCORRECT_ADJUSTMENT,
  ],
  [Team.ACCOUNT_BALANCING]: [
    JobType.RESOLVE_BALANCE_CHECKER,
    JobType.RESOLVE_PLAID_CONNECTION,
    JobType.RESOLVE_INCORRECT_BALANCE,
    JobType.SETUP_NEW_CONNECTION,
  ],
  [Team.THIRD_PARTY_LOGIN_STATEMENT_COLLECTION]: [
    JobType.COLLECT_MONTHLY_STATEMENT,
    JobType.COLLECT_ALL_LEDGER_STATEMENTS,
  ],
  [Team.QUALITY_REVIEW]: [JobType.RESOLVE_INCORRECT_BOOKS],
};

export const getJobTypesForTeam = (team: Team) => {
  return teamJobLookup[team];
};

export const getTeamFromJobType = (jobType: JobType): string | undefined => {
  return Object.keys(teamJobLookup).find(team => teamJobLookup[team].includes(jobType));
};
